// /app/frontend/src/lib/lisControlAgent.js
// Cliente del Agente de Control LIS (lis_control_agent.py) en localhost:9130.
// Permite prender/apagar los servidores de los analizadores y ver su estado.
// Solo funciona cuando el LIS se abre en la PC donde corre el agente.

const AGENT_URL = "http://localhost:9130";
const TIMEOUT = 3000;

const fetchWithTimeout = (url, options = {}, ms = TIMEOUT) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  return fetch(url, { ...options, signal: controller.signal }).finally(() =>
    clearTimeout(timer)
  );
};

// Devuelve el estado de todos los servidores. Si el agente no responde,
// available=false (el LIS se abrió fuera de la PC de recepción).
export const getAgentStatus = async () => {
  try {
    const res = await fetchWithTimeout(`${AGENT_URL}/status`, {}, 3000);
    const data = await res.json();
    return { available: true, servers: data.servers || {} };
  } catch {
    return { available: false, servers: {} };
  }
};

export const startServer = async (key) => {
  const res = await fetchWithTimeout(`${AGENT_URL}/start`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ server: key }),
  });
  return res.json();
};

export const stopServer = async (key) => {
  const res = await fetchWithTimeout(`${AGENT_URL}/stop`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ server: key }),
  });
  return res.json();
};
